import React from "react"
import Layout from "../components/layout"
import ServicesMainArea from "../components/ServicesMainArea"
import ServicesBox from "../components/ServicesBox"
import { graphql } from "gatsby"
import Arrow from "../components/Arrow"
import servicesImageTwo from "../../static/img/product-banner-hero-two.png"
import useWebsiteCmsContent from "../hooks/useWebsiteCmsContent"
import { localizedBlockData } from "../services/websiteCms"

export default function Services({
  data: {
    markdownRemark: {
      frontmatter: {
        title,
        description,
        contactUsButton,
        lang,
        canNotFindWhatIamLookingFor,
      },
    },
  },
}) {
  const cmsPayload = useWebsiteCmsContent()
  const page = localizedBlockData(cmsPayload, "services-page", lang) || {}

  return (
    <Layout lang={lang} title={page.title || title}>
      <ServicesMainArea
        img={servicesImageTwo}
        title={page.title || title}
        description={page.description || description}
      />
      <div className="b-homepage-content">
        <div className="b-layer-main">
          <Arrow />
          <ServicesBox
            lang={lang}
            contactUsButton={page.contactUsButton || contactUsButton}
            canNotFindWhatIamLookingForSection={page.canNotFindWhatIamLookingFor || canNotFindWhatIamLookingFor}
          />
        </div>
      </div>
    </Layout>
  )
}

export const query = graphql`
  query($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      frontmatter {
        title
        description
        lang
        contactUsButton
        canNotFindWhatIamLookingFor {
          title
          description
          askQuestionButton
        }
      }
    }
  }
`
